export interface SortOption {
  value: string;
  label: string;
}

export const SORT_OPTIONS: SortOption[] = [
  { value: 'pinned',       label: 'Pinned first' },
  { value: 'updated_desc', label: 'Last updated (newest)' },
  { value: 'updated_asc',  label: 'Last updated (oldest)' },
  { value: 'title_asc',    label: 'Title (A–Z)' },
  { value: 'title_desc',   label: 'Title (Z–A)' },
];

export const DEFAULT_SORT = 'pinned';

export const SORT_VALUES = SORT_OPTIONS.map((o) => o.value);

export function isValidSort(value: string | null | undefined): value is string {
  return !!value && SORT_VALUES.includes(value);
}

